import { defineMessages } from 'utils/intl';

export default defineMessages({
  parcelLockerTitle: 'Wysyłka do paczkomatu',
  parcelLockerDescription: 'Odbierz w paczkomacie InPost',
  freeShippingTitle: 'Darmowa dostawa kurierem',
  freeShippingDescription: 'Dla wszystkich zamówień',
  courierTitle: 'Dostawa kurierem',
  courierDescription: 'Na czas, bezpiecznie i bez stresu',
  leasingTitle: 'Weź leasing',
  leasingDescription: 'Bez wychodzenia z biura',
  guaranteeTitle: 'Tylko nowe produkty',
  guaranteeDescription: 'Oryginalne, gwarancja producenta',
  guaranteeDescriptionMobile: 'Gwarancja producenta',
});
